function initCountdowns() {
  const countdowns = document.querySelectorAll('.msg-cro_countdown');

  countdowns.forEach((el) => {
    const endRaw = el.dataset.end;

    if (!endRaw) return;

    const endTime = isNaN(endRaw)
      ? new Date(endRaw).getTime()
      : parseInt(endRaw, 10) * 1000;

    const dEl = el.querySelector('.countdown_d strong');
    const hEl = el.querySelector('.countdown_h strong');
    const mEl = el.querySelector('.countdown_min strong');
    const sEl = el.querySelector('.countdown_sec strong');

    const dWrap = el.querySelector('.countdown_d');
    const hWrap = el.querySelector('.countdown_h');

    function update() {
      const now = Date.now();
      const diff = endTime - now;

      if (diff <= 0) {
        dEl.textContent = 0;
        hEl.textContent = 0;
        mEl.textContent = 0;
        sEl.textContent = 0;

        dWrap.style.display = '';
        hWrap.style.display = '';
        clearInterval(timer);
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      dEl.textContent = days;
      hEl.textContent = hours;
      mEl.textContent = minutes;
      sEl.textContent = seconds;

      // display logic
      if (days > 0) {
        dWrap.style.display = '';
        hWrap.style.display = '';
      } else {
        dWrap.style.display = 'none';
        hWrap.style.display = hours > 0 ? '' : 'none';
      }
    }

    update();
    const timer = setInterval(update, 1000);
  });
}

document.addEventListener('DOMContentLoaded', initCountdowns);